import React, { Component } from "react";
import "./ChangePasswordModal.css";
import { toast } from "react-toastify";

export default class ChangePasswordModal extends Component {
  state = {
    actual: "",
    nueva: "",
    confirmar: "",
    showActual: false,
    showNueva: false,
  };

  componentDidUpdate(prevProps) {
    const openedNow = !prevProps.show && this.props.show;
    if (openedNow) {
      this.setState({
        actual: "",
        nueva: "",
        confirmar: "",
        showActual: false,
        showNueva: false,
      });
    }
  }

  validate = () => {
    const actual = String(this.state.actual || "").trim();
    const nueva = String(this.state.nueva || "").trim();
    const confirmar = String(this.state.confirmar || "").trim();

    if (!actual) return { ok: false, message: "Contraseña actual requerida." };
    if (!nueva) return { ok: false, message: "Nueva contraseña requerida." };
    if (nueva.length < 6) return { ok: false, message: "La nueva contraseña debe tener al menos 6 caracteres." };
    if (nueva !== confirmar) return { ok: false, message: "La confirmación no coincide." };

    //  SOLO mandamos vieja y nueva (sin idusuario)
    return {
      ok: true,
      payload: {
        actual: actual,
        nueva: nueva,
      },
    };
  };

  onSubmit = () => {
    const r = this.validate();
    if (!r.ok) {
      toast.info(r.message);
      return;
    }
    this.props?.onSave?.(r.payload);
  };

  render() {
    const { show, onClose, loading, user } = this.props;
    if (!show) return null;

    return (
      <div className="pm-backdrop">
        <div className="pm-modal" onClick={(e) => e.stopPropagation()}>
          <div className="pm-head">
            <h3 className="pm-title">Cambiar contraseña</h3>
            <button className="pm-x" onClick={loading ? null : onClose} aria-label="Cerrar">
              ✕
            </button>
          </div>

          <div className="pm-body">
            <div className="cpm-hint">
              Usuario: <b>{user?.nombre || "-"}</b>
            </div>

            <div className="pm-field">
              <label>Contraseña actual *</label>
              <input
                type={this.state.showActual ? "text" : "password"}
                value={this.state.actual}
                onChange={(e) => this.setState({ actual: e.target.value })}
                disabled={loading}
                autoComplete="current-password"
              />
              <button
                type="button"
                className="cpm-eye"
                onClick={() => this.setState((p) => ({ showActual: !p.showActual }))}
                disabled={loading}
              >
                👁
              </button>
            </div>

            <div className="pm-field">
              <label>Nueva contraseña *</label>
              <input
                type={this.state.showNueva ? "text" : "password"}
                value={this.state.nueva}
                onChange={(e) => this.setState({ nueva: e.target.value })}
                disabled={loading}
                autoComplete="new-password"
              />
              <button
                type="button"
                className="cpm-eye"
                onClick={() => this.setState((p) => ({ showNueva: !p.showNueva }))}
                disabled={loading}
              >
                👁
              </button>
            </div>

            <div className="pm-field">
              <label>Confirmar nueva contraseña *</label>
              <input
                type="password"
                value={this.state.confirmar}
                onChange={(e) => this.setState({ confirmar: e.target.value })}
                disabled={loading}
                autoComplete="new-password"
              />
            </div>
          </div>

          <div className="pm-foot pm-footCenter">
            <button className="pm-btn ghost" onClick={onClose} disabled={loading}>
              CANCELAR
            </button>
            <button className="pm-btn" onClick={this.onSubmit} disabled={loading}>
              ACTUALIZAR
            </button>
          </div>
        </div>
      </div>
    );
  }
}
